<template>

  <div>
    
    <textarea-autosize
      :placeholder="$t('Note')"
      v-model="value.note"
      :min-height="30"
      :max-height="350"
      class="form-control">
      </textarea-autosize>
    <ValidateMessage :error="validateErrors.note" />
    
    <div
      class="mt-3"
      v-if="value.note || enableCancel"
      :class="{'box-loading': loading}">
      <button  
        type="submit"
        class="btn btn-primary"
        @click="saveNote(value)">{{ $t('Save') }}</button>
      <button
        v-if="enableCancel"
        type="button"
        class="btn btn-secondary"
        @click="$emit('cancel')">{{ $t('Cancel') }}</button>
    </div>
  </div>

</template>

<script>
export default {
  name: 'CandidateNoteForm',
  components: {
  },
  props: [
    'initValue',
    'enableCancel'
  ],
  data () {
    return {
      validateErrors: false,
      loading: false,
      value: this.defaultValues(this.initValue)
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    saveNote
    */
    saveNote (data) {
      if (data._id) this.updateLog(data)
      else this.createLog(data)
    },
    /*
    resetLog
    */
    resetLog () {
      this.value.note = ''
      this.validateErrors = false
    },
    /*
    createLog
    */
    createLog (data) {
      this.loading = true

      data.job_id = this.job._id

      this.$store
      .dispatch('createRhevolutJob', data)
      .then((result) => {
        this.loading = false
        this.resetLog()
        this.$emit('created', result.data)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateLog
    */
    updateLog (data) {
      this.loading = true

      this.$store
      .dispatch('updateRhevolutJob', data)
      .then((result) => {
        this.loading = false
        this.$emit('updated', data)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RhevolutJob/RhevolutJobForm.vue